import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfTitle>{t('G_title')}</EfTitle>
            <div className="yyds pc">
                <div className="l">
                    <div className="box l-t">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126735764/-05.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text1_1')}</p>
                            <p className="text text2">{t('G_text1_2')}</p>
                        </div>
                    </div>
                    <div className="box l-b">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126736476/-06.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text2_1')}</p>
                            <p className="text text2">{t('G_text2_2')}</p>
                        </div>
                    </div>
                </div>
                <div className="m">
                    <div className="box m-t">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126735638/-01.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text3_1')}</p>
                            <p className="text text2">{t('G_text3_2')}</p>
                        </div>
                    </div>
                    <div className="box m-b">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126736031/-04.jpg" />
                        <div className="info">
                            <p className="text">{t('G_text4')}</p>
                        </div>
                    </div>
                </div>
                <div className="r">
                    <div className="box r-t">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126736689/-03.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text5_1')}</p>
                            <p className="text text2">{t('G_text5_2')}</p>
                        </div>
                    </div>
                    <div className="box r-b">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126736246/-02.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text6_1')}</p>
                            <p className="text text2">{t('G_text6_2')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="yyds h5">
                <div className="l1 box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126870710/-01.jpg" />
                    <div className="info">
                        <p className="text text1">{t('G_text3_1')}</p>
                        <p className="text text2">{t('G_text3_2')}</p>
                    </div>
                </div>
                <div className="l2 box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126870504/-02.jpg" />
                    <div className="info">
                        <p className="text">{t('G_text4')}</p>
                    </div>
                </div>
                <div className="l3">
                    <div className="l-l box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126870393/-03.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text3_1')}</p>
                            <p className="text text2">{t('G_text3_2')}</p>
                        </div>
                    </div>
                    <div className="l-r box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126869573/-04.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text5_1')}</p>
                            <p className="text text2">{t('G_text5_2')}</p>
                        </div>
                    </div>
                </div>
                <div className="l4">
                    <div className="l-l box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126870966/-05.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text2_1')}</p>
                            <p className="text text2">{t('G_text2_2')}</p>
                        </div>
                    </div>
                    <div className="l-r box">
                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726126869730/-06.jpg" />
                        <div className="info">
                            <p className="text text1">{t('G_text6_1')}</p>
                            <p className="text text2">{t('G_text6_2')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
